import { Link } from "@tanstack/react-router";
import type React from "react";

interface BreadcrumbItem {
  label: string;
  to?: string;
}

export interface BreadcrumbProps {
  items: BreadcrumbItem[];
  className?: string;
}

export const Breadcrumb: React.FC<BreadcrumbProps> = ({ items, className = "" }) => {
  return (
    <nav aria-label="Breadcrumb" className={className}>
      <ol className="flex items-center space-x-2 text-sm">
        {items.map((item, idx) => (
          <li key={item.label} className="flex items-center">
            {idx > 0 && (
              <svg
                className="w-4 h-4 text-gray-400 mx-2"
                fill="currentColor"
                viewBox="0 0 20 20"
                aria-hidden="true"
              >
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
            {item.to ? (
              <Link
                to={item.to}
                className={`${idx === items.length - 1 ? "text-primary" : "text-gray-500"} hover:text-gray-700`}
              >
                {item.label}
              </Link>
            ) : (
              <span
                className={`${idx === items.length - 1 ? "text-primary" : "text-gray-500"} hover:text-gray-700`}
                aria-current="page"
              >
                {item.label}
              </span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};
